module.exports = __webpack_public_path__ + "img/center-centent.23de91dc.png";